import { render, staticRenderFns } from "./TopTip.vue?vue&type=template&id=eb0731a6&scoped=true&"
import script from "./TopTip.vue?vue&type=script&lang=js&"
export * from "./TopTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0731a6",
  null
  
)

export default component.exports